import { putDirectorDetails, postDirectorDetails } from "../../../services/httpCalls"
import { cleanObject } from "../clean-object"

export const submitDirector = async ({
    values,
    setShowLoader,
    editDirector,
    selectionValue,
    checknationalityIndian,
    directorsDocsPAN,
    directorsDocsPASSPORT,
    directorsDocsAADHAR,
    editId,
    setRefreshDirectors,
    setOpen,
    refreshDirectors,
    form,
    setDirectorsDocsPAN,
    setDirectorsDocsAADHAR,
    setDirectorsDocsPASSPORT,
    setDocsDirector,
    notify,
    setRefresh
}) => {
    setShowLoader(true)
    let orgId = localStorage.getItem("orgId")
    if (editDirector) {
      let postFinalDataEdit
      if (selectionValue === "inward") {
        let finalDocs
        if (checknationalityIndian) {
          if (directorsDocsPAN.length) {
            finalDocs = directorsDocsPAN
          }else{
            finalDocs = directorsDocsAADHAR
          }
        } else {
          if (directorsDocsPASSPORT.length) finalDocs = directorsDocsPASSPORT
        }
        postFinalDataEdit = {
          emailId: values.emailId,
          name: values?.lastName ? (values.firstName + " " + values.lastName) : values.firstName,
          firstName: values.firstName,
          lastName: values?.lastName,
          phoneNumber: values.phoneNumber,
          nationality: values.nationality,
          panNumber: values.pan ? values.pan.toUpperCase() : "",
          dateOfAppointment: null,
          status: "ACTIVE",
          docs:
            finalDocs !== null || finalDocs !== undefined ? finalDocs : null,
          address: null,
          // pg
          dob: values.dateOfBirth ? values.dateOfBirth.format("DD/MM/YYYY") : null,
          designation: values.designation,
        }
      } else if (selectionValue === "outward") {
        let finalDocs
        if (checknationalityIndian) {
          if (directorsDocsAADHAR.length) {
            finalDocs = directorsDocsAADHAR
          }
        } else {
          if (directorsDocsPASSPORT.length) finalDocs = directorsDocsPASSPORT
        }
        postFinalDataEdit = {
          din: values.din,
          emailId: values.emailId,
          name: values?.lastName ? (values.firstName + " " + values?.lastName) : values.firstName,
          firstName: values.firstName,
          lastName: values?.lastName,
          phoneNumber: values.phoneNumber,
          nationality: values.nationality,
          panNumber: values.pan ? values.pan.toUpperCase() : "",
          dateOfAppointment: values?.dateOfAppointment
            ? values.dateOfAppointment?.format("DD/MM/YYYY")
            : null,
          address: {
            addressLineOne: values.addressLineOne,
            addressLineTwo: values.addressLineTwo,
            city: values.city,
            type: values.type,
            state: values.state,
            country: values.country,
            pinCode: values.pinCode
          },
          status: "ACTIVE",
          docs: finalDocs !== null || finalDocs !== undefined ? finalDocs : null
        }
      } else {

        let finalDocs
        if (checknationalityIndian) {
          if (directorsDocsAADHAR.length || directorsDocsPAN) {
            finalDocs = [...directorsDocsAADHAR, ...directorsDocsPAN]
          }
        } else {
          if (directorsDocsPASSPORT.length) finalDocs = directorsDocsPASSPORT
        }
        postFinalDataEdit = {
          din: values.din,
          emailId: values.emailId,
          name: values?.lastName ? (values.firstName + " " + values?.lastName) : values.firstName,
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          nationality: values.nationality,
          panNumber: values.pan ? values.pan.toUpperCase() : "",
          dateOfAppointment: values?.dateOfAppointment
            ? values.dateOfAppointment?.format("DD/MM/YYYY")
            : null,
          address: {
            addressLineOne: values.addressLineOne,
            addressLineTwo: values.addressLineTwo,
            city: values.city,
            type: values.type,
            state: values.state,
            country: values.country,
            pinCode: values.pinCode
          },
          status: "ACTIVE",
          docs: finalDocs !== null || finalDocs !== undefined ? finalDocs : null
        }
      }
      let cleanPostFinalDataEdit = cleanObject(postFinalDataEdit)
      await putDirectorDetails(orgId, editId, cleanPostFinalDataEdit)
        .then(res => {
          if (res !== undefined && !res?.errors) {
            setRefreshDirectors(!refreshDirectors)
            setOpen(false)
            form.resetFields()
            setDirectorsDocsPAN([])
            setDirectorsDocsAADHAR([])
            setDirectorsDocsPASSPORT([])
            setDocsDirector([])
          } else {
            notify.error(res.errors)
          }
        })
        .catch(err => {
          notify.error("Not able to update details!")
        })
        .finally(() => {
          setShowLoader(false)
        })
    } else {
      let postFinalDataCreate
      if (selectionValue === "inward") {
        let finalDocs
        if (checknationalityIndian) {
          if (directorsDocsAADHAR.length && directorsDocsPAN.length) {
            finalDocs = [...directorsDocsAADHAR, ...directorsDocsPAN]
          } else {
            if (directorsDocsPAN.length) {
              finalDocs = directorsDocsPAN
            }else{
              finalDocs = directorsDocsAADHAR
            }
          }
        } else {
          if (directorsDocsPASSPORT.length) finalDocs = directorsDocsPASSPORT
        }
        postFinalDataCreate = {
          emailId: values.emailId,
          name: values?.lastName ? (values.firstName + " " + values?.lastName) : values.firstName,
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          nationality: values.nationality,
          panNumber: values.pan ? values.pan.toUpperCase() : "",
          dateOfAppointment: null,
          status: "ACTIVE",
          docs:
            finalDocs !== null || finalDocs !== undefined ? finalDocs : null,
          address: null,
          // pg
          dob: values.dateOfBirth ? values.dateOfBirth.format("DD/MM/YYYY") : null,
          designation: values.designation,
        }
      } else if (selectionValue === "outward") {
        let finalDocs
        if (checknationalityIndian) {
          if (directorsDocsAADHAR.length) {
            finalDocs = directorsDocsAADHAR
          }
        } else {
          if (directorsDocsPASSPORT.length) finalDocs = directorsDocsPASSPORT
        }
        postFinalDataCreate = {
          din: values.din,
          emailId: values.emailId,
          name: values?.lastName ? (values.firstName + " " + values?.lastName) : values?.firstName,
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          nationality: values.nationality,
          panNumber: values.pan ? values.pan.toUpperCase() : "",
          dateOfAppointment: values?.dateOfAppointment
            ? values.dateOfAppointment?.format("DD/MM/YYYY")
            : null,
          address: {
            addressLineOne: values.addressLineOne,
            addressLineTwo: values.addressLineTwo,
            city: values.city,
            type: values.type,
            state: values.state,
            country: values.country,
            pinCode: values.pinCode
          },
          status: "ACTIVE",
          docs: finalDocs !== null || finalDocs !== undefined ? finalDocs : null
        }
      } else {
        let finalDocs
        if (checknationalityIndian) {
          if (directorsDocsAADHAR.length && directorsDocsPAN.length) {
            finalDocs = [...directorsDocsAADHAR, ...directorsDocsPAN]
          }
        } else {
          if (directorsDocsPASSPORT.length) finalDocs = directorsDocsPASSPORT
        }
        postFinalDataCreate = {
          din: values.din,
          emailId: values.emailId,
          name: values?.lastName ? (values.firstName + " " + values?.lastName) : values.firstName,
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          nationality: values.nationality,
          panNumber: values.pan ? values.pan.toUpperCase() : "",
          dateOfAppointment: values?.dateOfAppointment
            ? values.dateOfAppointment?.format("DD/MM/YYYY")
            : null,
          address: {
            addressLineOne: values.addressLineOne,
            addressLineTwo: values.addressLineTwo,
            city: values.city,
            type: values.type,
            state: values.state,
            country: values.country,
            pinCode: values.pinCode
          },
          status: "ACTIVE",
          docs: finalDocs !== null || finalDocs !== undefined ? finalDocs : null
        }
      }
      let orgId = localStorage.getItem("orgId")
      if (selectionValue === "inward") {
        delete postFinalDataCreate.address
      }
      let cleanPostFinalDataCreate = cleanObject(postFinalDataCreate)
      await postDirectorDetails(cleanPostFinalDataCreate, orgId)
        .then(res => {
          if (res !== undefined && !res?.errors) {
            notify.success("Successfully added director!")
            setRefreshDirectors(!refreshDirectors)
            setDirectorsDocsPAN([])
            setDirectorsDocsAADHAR([])
            setDirectorsDocsPASSPORT([])
            setDocsDirector([])
            form.resetFields()
            setOpen(false)
            setRefresh(true)
          } else {
            notify.error(res.errors)
          }
        })
        .catch(err => {
          notify.error("Not able to add director!")
        })
        .finally(() => {
          setShowLoader(false)
        })
    }
  }